import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_SALES_PAYMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_SALES_PAYMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_SALES_PAYMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_SALES_PAYMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_SALES_PAYMENT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
